import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DropdownService {
  private closeAllDropdowns$ = new Subject<void>();

  get onCloseAllDropdowns() {
    return this.closeAllDropdowns$.asObservable();
  }

  closeAll() {
    this.closeAllDropdowns$.next();
  }
}
